import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { Identity } from '@ppl/environment';
import { ButtonType } from '@ppl/ui/button';

@Component({
  selector: 'ppl-auth-message',
  standalone: false,
  templateUrl: './auth-message.component.html',
  styleUrl: './auth-message.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthMessageComponent {
  @Input() label: string;
  @Input() message: string;
  @Input() actionVisible = true;
  @Input() actionLabel: string;
  @Input() icon = 'logout-restriction';

  @Input() showIcon = true;

  @Output() action = new EventEmitter();

  Identity = Identity;
  ButtonType = ButtonType;

  onActionClick() {
    this.action.emit();
  }
}
